/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ref_N2Inputs */

const en_viewer_ref_n2 = /** @type {(inputs: Viewer_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A real number. No quotes in the raw text.`)
};

const ko_viewer_ref_n2 = /** @type {(inputs: Viewer_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`진짜 숫자입니다. 원문에 따옴표가 없습니다.`)
};

const ja_viewer_ref_n2 = /** @type {(inputs: Viewer_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本物の数値です。生のテキストに引用符がありません。`)
};

/**
* | output |
* | --- |
* | "A real number. No quotes in the raw text." |
*
* @param {Viewer_Ref_N2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ref_n2 = /** @type {((inputs?: Viewer_Ref_N2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ref_N2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ref_n2(inputs)
	if (locale === "ko") return ko_viewer_ref_n2(inputs)
	return ja_viewer_ref_n2(inputs)
});